import t from "@/lang/lang";
import {
  AirHandlingUnitSystem,
  Component,
  FreeTextData,
  Kind,
} from "@/services/backend/rlt/treatments/types/component";
import { SegmentKind } from "@/services/backend/rlt/treatments/types/segmentKind";

export interface Position {
  id: string;
  parentId?: string;
  children: Position[];
  number: string;
  component: Component;
  cycle: number;
  segmentKind: SegmentKind;
  area: string;
  comment: string;
  cleanTime: number;
  basePrice: number;
  cycleDiscountActive: boolean;
  cycleDiscountPercentage: number;
  specialDiscountActive: boolean;
  specialDiscountAmount: number;
  finalPrice: number;
  actuallyTreated: Component;
  completed: boolean;
  completedAt: string;
}

/**
 * positionTitle returns the fitting title for a position.
 * For some component kinds simply stating the kind is not
 * enough.
 * @param position
 */
export function positionTitle(position: Position): string {
  switch (position.component.kind) {
    case Kind.FreeText:
      return (position.component.data as FreeTextData).text;
    case Kind.AirHandlingUnitSystem:
      return (
        t("RLT-Anlage: ") +
        (position.component as AirHandlingUnitSystem).designation
      );
    default:
      return t(position.component.kind);
  }
}
